<div class="w-100 m-0 mt-1" *ngIf="!verHistorico">

    <div class="w-100 altura_vehicles">
        <kendo-grid *ngIf="!isLoadingVehicles" class="home-grid" [data]="gridView" height="{{height}}"
            [pageable]="false" [selectable]="true" [resizable]="false" [sort]="false"
            (cellClick)="selectVehiculo($event)">

            <kendo-grid-column field="PlateNumber" title="{{ 'labels.matricula' | translate }}" [width]="50">
            </kendo-grid-column>

            <kendo-grid-column field="Vin" title="{{ 'labels.vin' | translate }}" [width]="50">
            </kendo-grid-column>

            <kendo-grid-column field="ModelCode" title="{{ 'gestion_terceros.vehiculos.FLDCarModel' | translate }}"
                [width]="50">
            </kendo-grid-column>

            <kendo-grid-column field="ModelDescription"
                title="{{ 'gestion_terceros.vehiculos.FLDModelCode' | translate }}" [width]="50">
            </kendo-grid-column>

            <ng-template kendoGridNoRecordsTemplate>
                {{ 'genericos.messagesKendo.noDataAvailableNo' | translate }}
            </ng-template>
        </kendo-grid>


        <div class="kendo-loading" *ngIf="isLoadingVehicles">
            <span appCurrentColor class="k-icon k-i-loading big"></span>
        </div>


        <div class="row reset">
            <div class="col-12 mt-1">

                <button type="button" class="btn botonCS mr-2" [disabled]="deshabilitarBotones" (click)="getToOutApp()">
                </button>

                <button type="button" (click)="openModalVehicle()" class="btn btn-secondary  pix_125 mr-2 ">
                    {{'labels.anadir_vehiculo' | translate}}
                    <i class="fa fa-plus-circle" aria-hidden="true"></i>
                </button>
                <!-- Este botón va a Taller-Gestion OR- Paso 2 del wizard GEstionar OR , en orden de reparacion hay otro igual-->
                <div class="pix_125" *ngIf="gestionVehiculos || gestionOr">
                    <button type="button" class="btn btn-secondary   pix_125 mr-2">
                        {{'labels.gestion_or' | translate}}
                        <i class="fa fa-paste" aria-hidden="true"></i>
                    </button>
                </div>


                <button [disabled]="deshabilitarBotones" type="button" (click)="verHistoricoVehiculos()"
                    class="btn btn-secondary  pix_125 mr-2">
                    <i class="fa fa-search" aria-hidden="true"></i>
                    {{'labels.ver_historico'| translate}}
                </button>

                <button (click)="recepcionVehiculo()" [disabled]="deshabilitarBotones" type="button"
                    class="btn btn-secondary   pix_160 ">
                    <i class="fa fa-car" aria-hidden="true"></i>
                    {{'labels.recepcion_vehiculos'| translate}}
                </button>

            </div>

        </div>
    </div>
</div>

<!--  Boton Ver Historico -->
<div class="w-100 m-0 mt-1" *ngIf="verHistorico">
    <div class="w-100 altura_vehicles">
        <app-orden-reparacion (cancel)="cancelar()" [transmitter]="cargarVista">
        </app-orden-reparacion>
    </div>
</div>
